import {useEffect, useRef} from "react";
import {useProductReviews} from "../model/useProductReviews";
import {ProductReviewsFilters} from "./ProductReviewsFilters";
import {getReviewStats, ProductReviewItem, ProductReviewStats, Review} from "@/entities/product";
import {AddReviewButton} from "@/features/add-review";
import {pageEvents} from "@/shared/lib/events";
import {Button} from "@/shared/ui/Button";
import styles from "./ProductReviews.module.scss";

type Props = {
    reviews: Review[];
    ratingAVG: number | null;
    productId: number;
    numberOfCharacters?: number;
    reviewAdd: boolean;
}

export const ProductReviews = (
    {reviews, ratingAVG, productId, numberOfCharacters = 40, reviewAdd}: Props
) => {
    const {
        type,
        totalCountOfReviews,
        visibleReviews,
        reviewsWithImages,
        showMore,
        toggleExpand,
        expanded,
        changeType,
        hasMore
    } = useProductReviews(reviews);

    const ratingStats = getReviewStats(reviews);

    const ref = useRef<HTMLDivElement>(null);

    /**
     * Подписка на событие скрола
     */
    useEffect(() => {
        return pageEvents.scrollToReviews.on(() => {
            ref.current?.scrollIntoView({behavior: "smooth"});
        });
    }, []);

    return (
        <div ref={ref} className={styles.container}>
            <p className={styles.title}>Отзывы</p>
            {visibleReviews.length === 0 && (
                <p className={styles.noReviews}>На это украшение еще нет отзывов</p>
            )}
            {visibleReviews.length !== 0
                ? <div className={styles.body}>
                    <div className={styles.left}>
                        <ProductReviewsFilters
                            type={type}
                            totalCount={reviews.length}
                            withImagesCount={reviewsWithImages.length}
                            onClick={changeType}
                        />
                        <div className={styles.items}>
                            {visibleReviews.map((review) => {
                                return (
                                    <ProductReviewItem
                                        key={review.id}
                                        review={review}
                                        expanded={expanded}
                                        onToggleExpand={toggleExpand}
                                        numberOfCharacters={numberOfCharacters}
                                    />
                                );
                            })}
                        </div>
                        {hasMore && (
                            <Button variant={`secondary`} onClick={showMore}>Смотреть еще</Button>
                        )}
                    </div>
                    <div className={styles.right}>
                        <ProductReviewStats
                            ratingAVG={ratingAVG}
                            ratingStats={ratingStats}
                            totalCountOfReviews={totalCountOfReviews}
                        />
                        <AddReviewButton productId={productId} reviewAdd={reviewAdd} />
                    </div>
                </div>
                : <AddReviewButton productId={productId} reviewAdd={reviewAdd} />
            }
        </div>
    );
}
